/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Wifi_Mesh_NetworkInputs */



/**
* | output |
* | --- |
* | "No wifi mesh network" |
*
* @param {No_Wifi_Mesh_NetworkInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const no_wifi_mesh_network = /** @type {((inputs?: No_Wifi_Mesh_NetworkInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Wifi_Mesh_NetworkInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("No wifi mesh network")
	return /** @type {LocalizedString} */ ("Aucun réseau wifi mesh")
});